export type FeaturesMessages = {
  featuresText1: string;
  featuresText2: string;
  featuresText3: string;
  featuresText4: string;
  featuresText5: string;
  featuresText6: string;
  logoAlt: string;
};

export const featuresMessages: FeaturesMessages = {
  featuresText1: "Integrado ao seu WhatsApp cobrando através de um Link de pagamento",
  featuresText2:
    "Escolha o método de cobrança mais aderente ao processo de atendimento dos pedidos da sua empresa",
  featuresText3: "Permite que clientes paguem direto pelo WhatsApp, assim que finalizar o pedido",
  featuresText4:
    "Permite gerar cobranças únicas ou parceladas, receber de forma mista ou com mais de 1 cartão no link de pagamento",
  featuresText5: "Situação de pagamento disponível na listagem de pedidos Talk2Buy",
  featuresText6:
    "Acesso exclusivo a um Painel Financeiro com informações detalhadas e gestão de recebíveis",

  logoAlt: "T2Pay logo",
};
